import React, { memo } from 'react'

import SummaryWidget from './SummaryWidget'
import { STAKING_SYMBOL } from '../../util/wallet/staking.helpers'
// import CheckInIllustration from '../../assets/illustrations/check-in-illustration'

import stakingIcon from 'assets/staking-icon.png'

const StakingSummary = ({ t }) => {
  return (
    <SummaryWidget
      title={t('home.staked-balance', { symbol: STAKING_SYMBOL })}
      value={0}
      icon={stakingIcon}
    />
  )
}

export default memo(StakingSummary)
